export const SET_ERROR_STATUS = 'SET_ERROR_STATUS';
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_SOCKET_STATUS = 'SET_SOCKET_STATUS';
